import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { MaskedLines } from "@/components/motion/MaskedLines";
import { ProductGrid } from "@/components/shop/ProductGrid";
import { Seo } from "@/components/seo/Seo";
import { SEO } from "@/data/seo";
import { EASE } from "@/lib/motion";

export default function Shop() {
  const [params] = useSearchParams();
  const category = params.get("categoria") || "Tutti";

  return (
    <div className="bg-ivory pb-28 pt-40" data-testid="shop-page">
      <Seo {...SEO.shop} />
      <div className="container-pf">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-7">
            <p className="eyebrow">Benessere Silver Age</p>
            <h1 className="mt-5 font-display text-5xl font-medium leading-[1] text-navy sm:text-6xl lg:text-7xl">
              <MaskedLines onLoad delay={0.1} lines={["La collezione", <em className="italic text-copper">Perfero.</em>]} />
            </h1>
          </div>
          <p className="text-lg leading-relaxed text-slate2 lg:col-span-4 lg:col-start-9">Dieci prodotti, un'unica filosofia: la cura quotidiana pensata per la pelle che ha vissuto, con postbiotici dell'elicriso.</p>
        </div>
        <motion.div initial={{ clipPath: "inset(0% 50% 0% 50% round 2.5rem)" }} animate={{ clipPath: "inset(0% 0% 0% 0% round 2.5rem)" }} transition={{ duration: 1.4, delay: 0.2, ease: EASE }} className="mt-14 overflow-hidden rounded-[2.5rem]">
          <img src="/images/scene-couple.jpg" alt="La linea Perfero con una coppia di anziani sullo sfondo" className="aspect-[4/3] w-full object-cover object-[50%_85%] sm:aspect-[16/7]" data-testid="shop-banner" />
        </motion.div>
        <div className="mt-20">
          <ProductGrid key={category} initialCategory={category} />
        </div>
      </div>
    </div>
  );
}
